import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
export function FloatingCTA() {
  const handleWhatsApp = () => {
    const text = 'Hola, tengo aproximadamente USD y quisiera cotizar estos billetes. Adjunto fotos.';
    window.open(`https://wa.me/5491176110902?text=${encodeURIComponent(text)}`, '_blank');
  };
  return <div className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-lg border-t border-slate-200 md:hidden z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]" data-id="element-46">
      <button onClick={handleWhatsApp} className="w-full flex items-center justify-center gap-2 px-6 py-4 text-base font-bold text-white bg-[#0a2540] rounded-xl hover:bg-[#1a365d] transition-colors shadow-lg" data-id="element-47">
        <MessageCircle className="w-5 h-5" data-id="element-48" />
        Cotizar Ahora por WhatsApp
      </button>
    </div>;
}